import * as styled from "styled-components";
export const CommandBarStyle = styled.createGlobalStyle `
  :root {
    --opendash-commandbar-primary: var(--ant-primary-color);
    --opendash-commandbar-background: rgb(252 252 252);
    --opendash-commandbar-a1: rgba(0 0 0 / 0.05);
    --opendash-commandbar-a2: rgba(0 0 0 / 0.1);
    --opendash-commandbar-foreground: rgb(28 28 29);
    --opendash-commandbar-shadow: 0px 6px 20px rgb(0 0 0 / 20%);

    --opendash-commandbar-unit: 8px;
  }

  .opendash-commandbar--animator {
    max-width: 600px;
    width: 100%;
    background: var(--opendash-commandbar-background);
    color: var(--opendash-commandbar-foreground);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: var(--opendash-commandbar-shadow);
  }
  .opendash-commandbar--search {
    padding: 12px 16px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    background: var(--opendash-commandbar-background);
    color: var(--opendash-commandbar-foreground);
  }
  .opendash-commandbar--group {
    padding: 8px 16px;
    font-size: 10px;
    text-transform: uppercase;
    opacity: 0.5;
  }

  .opendash-commandbar--result {
    padding: 12px 16px;
    background: transparent;
    border-left: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .opendash-commandbar--result--active {
    background: var(--opendash-commandbar-a1);
    border-left: 2px solid var(--opendash-commandbar-primary);
  }

  .opendash-commandbar--result-container {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 14px;
  }

  .opendash-commandbar--result-content {
    display: flex;
    flex-direction: column;
  }

  .opendash-commandbar--result-title {
  }

  .opendash-commandbar--result-description {
    font-size: 12px;
  }

  .opendash-commandbar--result-icon {
  }

  .opendash-commandbar--result-parents-container {
  }

  .opendash-commandbar--result-parents-title {
    opacity: 0.5;
    margin-right: 8px;
  }

  .opendash-commandbar--result-parents-divider {
    margin-right: 8px;
  }

  .opendash-commandbar--result-keys {
    display: grid;
    grid-auto-flow: column;
    gap: 4px;
  }
  .opendash-commandbar--result-key {
    padding: 4px 6px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 14px;
  }
`;
//# sourceMappingURL=data:application/json;base64,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